import * as styled from "styled-components";
export const CommandBarStyle = styled.createGlobalStyle `
  :root {
    --opendash-commandbar-primary: var(--ant-primary-color);
    --opendash-commandbar-background: rgb(252 252 252);
    --opendash-commandbar-a1: rgba(0 0 0 / 0.05);
    --opendash-commandbar-a2: rgba(0 0 0 / 0.1);
    --opendash-commandbar-foreground: rgb(28 28 29);
    --opendash-commandbar-shadow: 0px 6px 20px rgb(0 0 0 / 20%);

    --opendash-commandbar-unit: 8px;
  }

  .opendash-commandbar--animator {
    max-width: 600px;
    width: 100%;
    background: var(--opendash-commandbar-background);
    color: var(--opendash-commandbar-foreground);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: var(--opendash-commandbar-shadow);
  }
  .opendash-commandbar--search {
    padding: 12px 16px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    background: var(--opendash-commandbar-background);
    color: var(--opendash-commandbar-foreground);
  }
  .opendash-commandbar--group {
    padding: 8px 16px;
    font-size: 10px;
    text-transform: uppercase;
    opacity: 0.5;
  }

  .opendash-commandbar--result {
    padding: 12px 16px;
    background: transparent;
    border-left: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .opendash-commandbar--result--active {
    background: var(--opendash-commandbar-a1);
    border-left: 2px solid var(--opendash-commandbar-primary);
  }

  .opendash-commandbar--result-container {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 14px;
  }

  .opendash-commandbar--result-content {
    display: flex;
    flex-direction: column;
  }

  .opendash-commandbar--result-title {
  }

  .opendash-commandbar--result-description {
    font-size: 12px;
  }

  .opendash-commandbar--result-icon {
  }

  .opendash-commandbar--result-parents-container {
  }

  .opendash-commandbar--result-parents-title {
    opacity: 0.5;
    margin-right: 8px;
  }

  .opendash-commandbar--result-parents-divider {
    margin-right: 8px;
  }

  .opendash-commandbar--result-keys {
    display: grid;
    grid-auto-flow: column;
    gap: 4px;
  }
  .opendash-commandbar--result-key {
    padding: 4px 6px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 14px;
  }
`;
//# sourceMappingURL=data:application/json;base64,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